<template>
    <div class="login-form">
        <ModalHeader :title="mode === LOGIN_MODE.LOGIN ? '로그인' : '회원가입'"/>
        <div style="margin-top:30px; padding:0px 20px;">
            <template v-if="is_development">
                <div class="form-group">
                    <label for="id">아이디</label>
                    <input
                            type="text"
                            id="id"
                            v-model="formData.id"
                            placeholder="아이디를 입력하세요"
                            @keyup="next($event, 'password_el')"
                            enterkeyhint="next"
                    >
                </div>

                <div class="form-group">
                    <label>비밀번호</label>
                    <input
                            type="password"
                            v-model="formData.password"
                            ref="password_el"
                            placeholder="비밀번호를 입력하세요"
                            @keyup="enter($event)"
                            enterkeyhint="done"
                    >
                </div>

                <ProgressButton
                        buttonText="로그인"
                        :showProgress="isSubmitting"
                        @click="handleSubmit"
                />
            </template>


            <!--<div  style="display:flex; margin-top:10px;">-->
                <!--<div style="flex:1;"></div>-->
                <!--<div style="padding:5px 0px 5px 10px; text-decoration: underline; color:#8e8d8d" @click="goRegister">회원가입</div>-->
            <!--</div>-->

            <div v-if="mode === LOGIN_MODE.LOGIN" style="text-align:center; font-weight:bold;">SNS 계정으로 로그인</div>
            <div v-if="mode === LOGIN_MODE.REGISTER" style="text-align:center; font-weight:bold;">SNS 계정으로 로그인/가입하기</div>

            <div style="display:flex; justify-content: center;gap: 15px; margin-top:15px;">
                <div style="width:80px; height:80px; display:grid; place-items: center; border-radius:20px; background-color: #fde501;" @click="loginKaKao">
                    <img :src="require('@/assets/img/kakao_logo.png')" style="width:46px;">
                </div>
                <div style="width:80px; height:80px; display:grid; place-items: center; border-radius:20px; background-color: #2fb050;" @click="loginNaver">
                    <img :src="require('@/assets/img/naver_logo.png')" style="width:35px;">
                </div>
                <div v-if="isIOS" style="width:80px; height:80px; display:grid; place-items: center; border-radius:20px; background-color: black;" @click="loginApple">
                    <img :src="require('@/assets/img/apple_logo.png')" style="width:40px;">
                </div>
            </div>

            <!--<div style="margin-top:10px;">-->
                <!--<div class="login_btn_wrap" style="background-color: #ffda3b;" @click="loginKaKao">-->
                    <!--<img :src="require('@/assets/img/kakao_icon.png')" style="width: 18px; margin:0px 10px;">-->
                    <!--<div class="login_btn_text">카카오 아이디 로그인</div>-->
                <!--</div>-->
                <!--<div class="login_btn_wrap" style="background-color: #03c75a;" @click="loginNaver">-->
                    <!--<img :src="require('@/assets/img/naver_icon.png')" style="width: 18px; margin:0px 10px;">-->
                    <!--<div class="login_btn_text" style="color:white;">네이버 아이디 로그인</div>-->
                <!--</div>-->
                <!--<div v-if="isIOS" class="login_btn_wrap" style="background-color: black;" @click="loginApple">-->
                    <!--<img :src="require('@/assets/img/apple_icon.jpg')" style="width: 18px; margin:0px 10px;">-->
                    <!--<div class="login_btn_text" style="color:white;">애플 아이디 로그인</div>-->
                <!--</div>-->
            <!--</div>-->

            <!--<button @click="test" style="font-size:20px; padding:10px; margin-top:20px;">테스트</button>-->

        </div>
    </div>
</template>

<script>
import ProgressButton from '../common/ProgressButton.vue'
import ModalHeader from "../common/ModalHeader";
import ResponseCode from "../../ResponseCode";

export const LOGIN_MODE = {
    LOGIN : 0,
    REGISTER : 1,
}

export default {
    name: "Login",
    components: {
        ModalHeader,
        ProgressButton
    },
    props : {
        mode : {
            type : Number,
            default : LOGIN_MODE.LOGIN
        },
    },
    data() {
        return {
            LOGIN_MODE : LOGIN_MODE,
            formData: {
                id: '',
                password: ''
            },
            isSubmitting: false,
            is_development : false,
        }
    },
    computed: {
        isIOS() {
            const device = this.$cookies.get('device');
            return device === 'ios';
        },
        isApp(){
            const device = this.$cookies.get('device');
            return device === 'ios' || device === 'android';
        }
    },
    methods: {
        test(){
            // window.Android.checkPermission();
            // const beacons = window.Android.getBeaconData();
            //
            // alert(JSON.stringify(JSON.parse(beacons).map(item => item.distance)));

            // window.setBeaconData = (beacons) => {
            //     alert(beacons);
            //     // alert(JSON.stringify(JSON.parse(beacons).map(item => item.distance)));
            // };
            //
            // /*eslint-disable no-undef */
            // webkit.messageHandlers.ios.postMessage({ cmd: 'getBeaconData'});


        },
        next(e, next_target_key){
            if(e.keyCode === 13){
                this.$refs[next_target_key].focus();
            }
        },
        enter(e){
            if(e.keyCode === 13){
                this.handleSubmit();
            }
        },
        goRegister(){
            this.$GlobalRouter.push('/register?b=1&ver=' + new Date().getTime());
        },
        async handleSubmit() {
            if(this.formData.id === ''){
                this.$GlobalStore.showAlert('아이디를 입력해주세요.');
                return;
            }

            if(process.env.NODE_ENV === 'production' && this.formData.password === ''){
                this.$GlobalStore.showAlert('비밀번호를 입력해주세요.');
                return;
            }

            this.isSubmitting = true;

            const parameters = {};
            parameters.id = this.formData.id;
            parameters.password = this.formData.password;

            const res = await this.$Axios.post('/api/login', parameters);
            this.isSubmitting = false;
            if(res.data.code === ResponseCode.SUCCESS){
                this.$GlobalStore.closeLastModal();
                this.$GlobalStore.setLoginInfo(res.data.loginInfo);
                await this.$Util.checkAfterLogin();
                // this.$GlobalRouter.push('/view/reservation?' + new Date().getTime());
            }else if(res.data.code === ResponseCode.FAIL){
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        async loginKaKao(){
            const device = this.$cookies.get('device');

            let domain = '';
            if(process.env.NODE_ENV === 'development'){
                domain = 'http://192.168.0.203:8104';
            }

            let query = '';
            if (device === 'android' || device === 'ios') {
                const pushToken = await window.pushCustomManager.getPushToken();
                const uuid = await window.pushCustomManager.getUuid();
                query = `?uuid=${uuid}&pushToken=${pushToken}`;
            }

            if (device === 'ios') {
                const url = (domain ? domain : location.origin) + "/login/kakao/form" + query;
                /*eslint-disable no-undef */
                webkit.messageHandlers.ios.postMessage({ cmd: 'showWebView', url: url });
                // this.$GlobalStore.addModal('KaKaoLogin', { transitionName: '' });
            } else {
                const url = domain + "/login/kakao/form" + query;
                window.open(url);
            }
        },
        async loginNaver() {
            const device = this.$cookies.get('device');

            let domain = '';
            if(process.env.NODE_ENV === 'development'){
                domain = 'http://192.168.0.203:8104';
            }

            let query = '';
            if (device === 'android' || device === 'ios') {
                const pushToken = await window.pushCustomManager.getPushToken();
                const uuid = await window.pushCustomManager.getUuid();
                query = `?uuid=${uuid}&pushToken=${pushToken}`;
            }

            if (device === 'ios') {
                const url = (domain ? domain : location.origin) + "/login/naver/form" + query;
                /*eslint-disable no-undef */
                webkit.messageHandlers.ios.postMessage({ cmd: 'showWebView', url: url });
            } else {
                const url = domain + "/login/naver/form" + query;
                window.open(url);
            }
        },
        async loginApple() {
            /*eslint-disable no-undef */
            webkit.messageHandlers.ios.postMessage({ cmd: 'loginApple' });
        },
    },
    created(){
        this.handleSubmit = this.$Once(this.handleSubmit);

        if(process.env.NODE_ENV === 'development'){
            this.is_development = true;
        }

        window.loginApple = async (id) => {
            const parameters = {};
            parameters.id = id;

            const device = this.$cookies.get('device');
            if (device === 'android' || device === 'ios') {
                parameters.pushToken = await window.pushCustomManager.getPushToken();
                parameters.uuid = await window.pushCustomManager.getUuid();
            }

            const res = await this.$Axios.post('/login/apple', parameters);
            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.closeLastModal();
                this.$GlobalStore.setLoginInfo(res.data.loginInfo);
                await this.$Util.checkAfterLogin();
                this.$GlobalRouter.push('/view/home?' + new Date().getTime());
            } else if(res.data.code === 1){
                this.$GlobalStore.closeLastModal();
                this.$GlobalStore.addModal('MemberRegister', {id : id, mode : res.data.platform});
            } else {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        }

    }
}
</script>

<style scoped>
.login-form {
    /*max-width: 400px;*/
    /*margin: 0 auto;*/
}

.form-group {
    margin-bottom: 20px;
}

label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
}

input {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    height: 44px;
}

button {
    padding: 8px 16px;
    background-color: #4CAF50;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    height: 44px;
}

button:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
}

.error-message {
    color: red;
    font-size: 12px;
    margin-top: 5px;
    display: block;
}

    .login_btn_wrap{
        padding:10px;width:100%; display:flex; align-items: center;  height:44px; justify-content: center; border-radius: 4px;
        margin-top:15px;
    }
    .login_btn_text{font-weight:bold;}
</style> 